module.exports = __webpack_public_path__ + "static/media/IMG_7280_DxO.4ff37e69.jpg";